<script>
import {getToken} from "../../../js-core/conn/auth/auth-main"
import {BSGet, BSPost} from "../../../js-core/conn/reqs"
import UserContent from '../UserContent.svelte'
const content = document.createElement('p')
content.textContent = 'Modal content.'
let modalOpen = false
let selectedFromUserContentBucketId
let uploadLoading, vis = {upload: false, chooseUserFiles: true}
// either "box", "dropbox", "file"
let selected = {type: "", url: null, fileElem: null}
let errOccured, errMsg
export let bucketId, success

function changeTabVis(key) {
    for (let k in vis) {
        if (k !== key) vis[k] = false
    }
    vis[key] = true
}

function openContentUpload(node) {
    setTimeout(() => {
    let fileElem = document.getElementById('file')
    fileElem.onchange = (e) => { 
        selected.type = "file"
        selected.fileElem = fileElem
    };
    /* Box Select */
    let boxSelect = new BoxSelect();
    // Register a success callback handler
    boxSelect.success(response => {
        selected.type = "box"
        selected.url = response[0].url
    });
    // Register a cancel callback handler
    boxSelect.cancel(function() {
        console.log("The user clicked cancel or closed the popup");
    });

    /* dropbox select */
    const dropBoxOptions = {
        // Required. Called when a user selects an item in the Chooser.
        success: (files) => {
            selected.type = "dropbox"
            selected.url = files[0].link
        },
        cancel: () => {},
        linkType: "direct",
        multiselect: false, // or true
        extensions: ['images'], // consider .png, .jpg etc
        folderselect: false,
        sizeLimit: 1024 * 1024 * 1024 * 1024, // 1 Gig
    };
    let dropboxBtn = Dropbox.createChooseButton(dropBoxOptions);
    dropboxBtn.style.height = '100%'
    dropboxBtn.style.width = '100%'
    document.getElementById("dropbox-select").appendChild(dropboxBtn);
    }, 100);
}

async function uploadImgUrl(url) {
    try {
        const ret = await BSPost('image/ad-url' , JSON.stringify({url}))
        if (ret.status !== 201) {
            errOccured = true
            const retBody = await ret.json()
            errMsg = retBody.response.status
        } else {
            const retBody = await ret.json()
            errOccured = false
            success = true
            uploadLoading = false
            bucketId = retBody.id
        }
    } catch (e) {
        console.error(e)
        errOccured = true
        throw "An error occured while uploading your content"
    }
}

async function uploadFileElem() {
    if(!selected.fileElem) {
        alert('please select a file')
    } else {
        const contentType = "image/png";
        const formData = new FormData();
        formData.append("file", selected.fileElem.files[0]);
        formData.append("contentType", contentType);
        const res = await BSFetch("image/ad-file", {
          method: "POST",
          headers: {
            authorization: getToken()
          },
          body: formData,
          mode: "cors",
          cache: "no-cache"
        });
        const resBody = await res.json();
        if (res.status === 201) {
          errOccured = false
          success = true
          bucketId = resBody.response.id
        } else {
            if (res.status === 400)
            errMsg = resBody.response.status
          console.log(errMsg)
          errOccured = true
          uploadLoading = false
        }
    }
}

async function submitFile(e) {
    e.preventDefault();
    if (vis.chooseUserFiles === true) {
        success = true
        modalOpen = false
        bucketId = selectedFromUserContentBucketId
        return
    }
    uploadLoading = true
    success = false
    errOccured = false
    try {

        if (selected.type === "box" || selected.type === "dropbox")
            await uploadImgUrl(selected.url)
        else
            await uploadFileElem()
        if (success) {
            alert('Your content has been successfully uploaded')
            modalOpen = false
        }
    } catch (e) {
        errOccured = true
        uploadLoading = false
        errMsg = e
    }
    uploadLoading = false
}
</script>
<style>
    .modal-body :global(img) {
        padding: 0.1rem;
    }
    .modal-body {
        max-height: 50vh;
        overflow-y: scroll;
    }
   .modal {
        justify-content: center;
        align-items: center;
    }
    button.close {
        margin-right: 1rem;
    }
</style>
<div class="row">
    <div class="col-12">
        <button type="button" class="btn normal" on:click="{() => { modalOpen = true;}}">
            Upload your content!
        </button>
    </div>
    {#if success}
    <div class="col-12">
        Your content has successfully been selected
    </div>
    {/if}

</div>

<div id="modalUploadFile" class="modal fade" role="dialog" style={modalOpen ? 'display: flex!important; position: static!important; overflow: visible; opacity: 100%;' : 'display: none;'}>
    <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
            <div class="modal-header">
                <ul class="nav nav-tabs">
                    <li class="nav-item">
                        <a href="/" class="nav-link {vis.upload ? 'active' : ''}" on:click={(e) => { e.preventDefault(); changeTabVis('upload');}}>
                            Upload File
                        </a>
                    </li>
                    <li class="nav-item">
                        <a href='/' class="nav-link {vis.chooseUserFiles ? 'active' : ''}" on:click={(e) => {e.preventDefault(); changeTabVis('chooseUserFiles')}}>
                            Your Files
                        </a>
                    </li>
                </ul>
                <button type="button" class="close" on:click={() => modalOpen = false}>&times;</button>
            </div>
            <div class="modal-body">
                {#if vis.upload}
                <p>Choose either from your files, Box, or Dropbox</p>
                <input type="file" class="" id="file" accept="image/png,image/jpg" />
                or
                <div class="row">
                    <div class="col-8">
                        <div id="box-select" data-link-type="YOUR_LINK_TYPE" data-multiselect="false" data-client-id="YOUR_CLIENT_ID"></div>
                    </div>
                </div>
                or
                <div class="row">
                    <div class="col-8">
                        <div id="dropbox-select"></div>
                    </div>
                </div>
                <div use:openContentUpload></div>
                {:else if vis.chooseUserFiles}
                    <UserContent bind:selectedBucketId={selectedFromUserContentBucketId}/>
                {/if}
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-default" on:click={() => modalOpen=false}>Close</button>
                <button type="button" class="btn normal {uploadLoading ? 'loading' : ''}" on:click={(e) => submitFile(e)}>Submit File</button>
                <p>
                    {#if errOccured}
                        {errMsg}
                    {/if}
                </p>
            </div>
        </div>
    </div>
</div>
<!-- TODO multi support -->
<br />
<!-- Google Drive refrence -->
<!-- https://developers.google.com/drive/api/v3/picker -->

<!-- Box refrence -->
<!-- https://box-content.readme.io/docs/the-box-file-picker -->

<!-- Dropbox refrence -->
<!-- https://www.dropbox.com/developers/chooser -->